import { configureStore, combineReducers } from "@reduxjs/toolkit";
import user from "./reducers/user";
import rate from "./reducers/rate";
import bookings from "./reducers/bookings";

const rootReducer = combineReducers({ user, rate, bookings });

export const store = configureStore({ reducer: rootReducer });
